export default __webpack_public_path__ + "static/media/shippieLogo.c22cae11.png";